import React, { useEffect, useRef, useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { forgetPassword, signIn } from '../../features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../components/UIElements/Spinner';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getMenuItems } from '../../components/UIElements/sidebarConfig';
import { logout } from '../../utils/logout';

const Signin = () => {
  const divRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState('login');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [password, setPassword] = useState(false);
  const [error, setError] = useState(null);
  const loggedUserDetails = useSelector((state) => state?.auth?.successData);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (type === 'login') {
      try {
        const response = await dispatch(signIn(formData)).unwrap();
        if (response.status === 200 && typeof response?.data === 'object') {
          const MENU_ITEMS = getMenuItems(
            response?.data?.userDetails,
            response?.data?.userPermissions,
            response?.data?.webServices,
          );
          const firstRoute = MENU_ITEMS?.[0]?.route;
          localStorage.setItem('access_token', response?.data?.access_token);
          localStorage.setItem(
            'userName',
            response?.data?.userDetails?.userName,
          );
          localStorage.setItem(
            'smsService',
            response?.data?.userDetails?.smsService,
          );

          navigate(firstRoute);
        } else {
          setError('Something went wrong. Please try again later .');
        }
      } catch (error) {
        if (error?.status === 401) {
          setError('Invalid Credentials! Enter Valid Details');
        } else if (error?.status === 423)
          setError('Access denied,Please contact @support team');
        else {
          setError('Something went wrong. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await dispatch(
          forgetPassword(formData?.email),
        ).unwrap();
        if (response?.status === 200) {
          alert(
            'Please check your email to know the about your login detials !',
          );
          setError('');
          setFormData({
            email: '',
            password: '',
          });
        }
        if (response?.status === 203) {
          setError('Invalid email Id! Enter valid email');
        }
      } catch (error) {
        {
          setError('Something went wrong. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    }
  };
  async function clearState() {
    await logout();
  }
  useEffect(() => {
    const div = divRef.current;
    if (!div) return;
    // Create a ResizeObserver to watch the div height
    const resizeObserver = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      setDimensions({ width, height, isSmall: height < 400 });
    });
    resizeObserver.observe(div);
    // if not  token clear the store
    if (!localStorage.getItem('access_token')) {
      clearState();
    }
    // Cleanup on unmount
    return () => resizeObserver.disconnect();
  }, []);
  //If user already logged in just navigate to the first dashboard item of the corresponding using  user permissions
  if (loggedUserDetails && localStorage.getItem('access_token')) {
    const MENU_ITEMS = getMenuItems(
      loggedUserDetails?.userDetails,
      loggedUserDetails?.userPermissions,
      loggedUserDetails?.webServices,
    );
    const firstRoute = MENU_ITEMS?.[0]?.route;

    navigate('/' + firstRoute);
  }
  return (
    <>
      <div
        className='flex shadow-md size-full rounded-3xl aspect-square'
        ref={divRef}
      >
        <div className='flex-1 max-md:hidden'>
          <img
            src='images/login-cover-page.png'
            className=' size-full rounded-l-3xl aspect-auto'
          ></img>
        </div>

        <div
          className='relative bg-white flex-1 max-[400px]:p-2 h-full max-md:w-full flex flex-col  justify-center
                max-md:rounded-3xl rounded-r-3xl overflow-hidden  text-center'
        >
          {!dimensions?.isSmall && (
            <img
              src='/images/SVClassEdge.png'
              className='max-h-20 h-auto block w-[200px] object-fill mx-auto'
            ></img>
          )}

          <Typography className='my-0 text-2xl font-semibold '>
            {' '}
            Welcome Back!
          </Typography>
          <Typography className='m-0 mb-2 text-base font-normal'>
            One step behind for your Application
          </Typography>

          {loading && <Spinner asOverlay={true} />}
          {error && (
            <Typography className='mb-1 text-center text-red-600'>
              {error}
            </Typography>
          )}
          <form
            onSubmit={handleSubmit}
            className='block max-w-sm mx-auto space-y-3 md:px-8'
          >
            <TextField
              fullWidth
              label='Email'
              name='email'
              type='email'
              size={dimensions?.isSmall ? 'small' : ''}
              value={formData.email}
              onChange={handleChange}
              required
              className='bg-white'
            />

            {type === 'login' && (
              <TextField
                fullWidth
                autoComplete='off'
                label='Password'
                size={dimensions?.isSmall ? 'small' : ''}
                name='password'
                type={password ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                required
                InputProps={{
                  className: 'bg-white',
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={() => setPassword((show) => !show)}
                        edge='end'
                        size='small'
                      >
                        {password ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className='bg-white'
              />
            )}

            <Button
              type='submit'
              variant='contained'
              fullWidth
              className='py-2 bg-blue-600 hover:bg-blue-700'
            >
              {type === 'forget' ? 'Submit' : 'Sign In'}
            </Button>
            {type === 'login' && (
              <Typography
                className='mr-auto text-blue-600 cursor-pointer hover:underline'
                onClick={() => {
                  (setType('forget'),
                    setFormData({
                      email: '',
                      password: '',
                    }),
                    setError(''));
                }}
              >
                Forget Password?
              </Typography>
            )}
            {type === 'forget' && (
              <Typography
                className='text-blue-600 cursor-pointer hover:underline'
                onClick={() => {
                  (setType('login'),
                    setFormData({
                      email: '',
                      password: '',
                    }),
                    setError(''));
                }}
              >
                Back to SignIn
              </Typography>
            )}
          </form>
          <Typography className='text-gray-600'>
            Don't have an account?{' '}
            <span
              onClick={() => navigate('/registration')}
              className='text-blue-600 cursor-pointer hover:underline'
            >
              SignUp Here
            </span>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default Signin;
